export default __webpack_public_path__ + "static/char-s-01-cht-82628f9e5a0e22fd0e2b00ee33e65ae8.png";